module.exports = __webpack_public_path__ + "img/thumbp2p1.6582c4fb.png";